import React from "react";

const ContentRow = ({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) => {
  return (
    <div className="row">
      <div className="title">{title}</div>
      <div className="content">{children}</div>
    </div>
  );
};

export default ContentRow;
